import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { LogoMark } from "@/components/Logo";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated. Please sign in.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="debii-shell flex flex-col px-6 py-12">
      <div className="flex-1 flex flex-col justify-center max-w-sm w-full mx-auto">
        <LogoMark size={52} />
        {!token ? (
          <p className="mt-6 text-sm text-muted-foreground">This reset link is invalid.</p>
        ) : done ? (
          <>
            <h1 className="mt-6 font-display text-2xl font-bold">Password updated ✓</h1>
            <Button onClick={() => navigate("/auth?mode=login")} className="mt-6 w-full h-12 rounded-xl">Sign In</Button>
          </>
        ) : (
          <>
            <h1 className="mt-6 font-display text-2xl font-bold">Choose a new password</h1>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" className="h-12 rounded-xl" />
              <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl">{loading ? "Saving…" : "Update password"}</Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
